"use strict";
var MetadataHelper_1 = require('./MetadataHelper');
exports.MetadataHelper = MetadataHelper_1.MetadataHelper;
var MetadataFactory_1 = require('./MetadataFactory');
exports.PropertyAnnotationFactory = MetadataFactory_1.PropertyAnnotationFactory;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ts-metadata-helper/index.js
// module id = 494
// module chunks = 0